import { MoonStar, SunIcon } from '@music-vine/cadence/icons';
import { useContext, useEffect, useMemo, useState } from 'react';
import { Button } from '@music-vine/cadence/ui';
import { cn } from '@/lib/utils';
import { SidebarContext } from '@/providers/SidebarProvider';
import { ThemeContext } from '@/providers/ThemeProvider';
import { isMacOS } from '@/utils/browserDetection';
import ThemeIcon from './ThemeIcon';
import { KeyboardShortcutsTooltip } from '@/features/AudioPlayer';
const ThemeToggle: React.FC<{
  className?: string;
}> = ({
  className
}) => {
  const {
    theme,
    toggleTheme
  } = useContext(ThemeContext);
  const {
    isSidebarToggled
  } = useContext(SidebarContext);
  const [isMacOs, setIsMacOs] = useState(false);
  useEffect(() => {
    setIsMacOs(isMacOS());
  }, []);
  const keyCombo = useMemo(() => [isMacOs ? '⌘' : 'Ctrl', 'Shift', 'L'], [isMacOs]);
  return <KeyboardShortcutsTooltip keys={keyCombo} label={theme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'} side={isSidebarToggled ? 'right' : 'top'} data-sentry-element="KeyboardShortcutsTooltip" data-sentry-component="ThemeToggle" data-sentry-source-file="index.tsx">
      <Button aria-label="Toggle theme" borderRadius="full" className={cn('relative size-7 shrink-0 overflow-hidden active:border-transparent! active:bg-transparent!', className)} onClick={toggleTheme} size="icon" variant="transparent" data-sentry-element="Button" data-sentry-source-file="index.tsx">
        <ThemeIcon className="-translate-y-1/2 opacity-100 dark:translate-y-12 dark:opacity-10" data-sentry-element="ThemeIcon" data-sentry-source-file="index.tsx">
          <SunIcon className="size-4" data-sentry-element="SunIcon" data-sentry-source-file="index.tsx" />
        </ThemeIcon>
        <ThemeIcon className="translate-y-12 opacity-10 dark:-translate-y-1/2 dark:opacity-100" data-sentry-element="ThemeIcon" data-sentry-source-file="index.tsx">
          <MoonStar className="size-4" data-sentry-element="MoonStar" data-sentry-source-file="index.tsx" />
        </ThemeIcon>
      </Button>
    </KeyboardShortcutsTooltip>;
};
export default ThemeToggle;